import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from "../../services/http-client.service";
import { DomSanitizer } from "@angular/platform-browser";
import { WebsiteThemeService } from "../../services/website-theme.service";
import { ActivatedRoute, Router } from "@angular/router";
let PromotionComponent = class PromotionComponent {
    constructor(httpClient, sanitizer, themeService, router, route) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.router = router;
        this.route = route;
        this.backColor = '';
        this.accentColor = '';
        this.mainColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.textColor = '';
        this.errorColor = '';
        this.successColor = '';
        this.linkColor = '';
        this.inputBackColor = '';
        this.user = JSON.parse(localStorage.getItem('user'));
        this.promoCode = '';
        this.successMessage = false;
        this.error = false;
        this.errorMessage = '';
        this.promoCodeClicked = false;
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    ngOnInit() {
    }
    valuechange(e) {
        this.promoCodeClicked = false;
    }
    usePromoCode() {
        if (this.promoCodeClicked == true)
            return;
        const data = {
            promo_code: this.promoCode
        };
        this.promoCodeClicked = true;
        this.httpClient.post('promotion/usepromocode', data).subscribe((data) => {
            this.successMessage = true;
            this.error = false;
        }, (error) => {
            this.error = true;
            this.errorMessage = error.error;
        });
    }
};
PromotionComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: Router },
    { type: ActivatedRoute }
];
PromotionComponent = __decorate([
    Component({
        selector: 'app-promotion',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./promotion.component.html")).default
    })
], PromotionComponent);
export { PromotionComponent };
